import script from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"
export * from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"

import "./IntakeOpsReview.vue?vue&type=style&index=0&id=c54b5776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c54b5776"]])

export default __exports__